export default __webpack_public_path__ + "static/media/Create-documentation.56e00bc8.md";